import CameraSolidSVG from "@design-system/ui-icons/vanilla/CameraSolid"
import { createIcon } from "../createIcon"

export const CameraSolidIcon = createIcon(CameraSolidSVG)
